/* eslint-disable no-useless-return */
/* eslint-disable eqeqeq */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/naming-convention */
import ITokenService from '../../interfaces/ITokenService';
import cryptography from './cryptography.service';
import { appInsights } from '../../AppInsights';

class TokenService implements ITokenService {
  static accessTokenKey:string = 'access_token';

  static refreshTokenKey:string = 'refresh_token';

  static codeVerifierKey: string = 'code_verifier';

  // New PA Session
  static newSession: string = 'NEW_SESSION';

  // Save and comeback session
  static resumeSession: string = 'RESUME_SESSION';

  createNewSession(): string {
    // Remove access token
    const accessToken = sessionStorage.getItem(TokenService.accessTokenKey);
    if (accessToken) {
      sessionStorage.removeItem(TokenService.accessTokenKey);
    }

    // Remove refresh token
    const refreshToken = sessionStorage.getItem(TokenService.refreshTokenKey);
    if (refreshToken) {
      sessionStorage.removeItem(TokenService.refreshTokenKey);
    }

    // Initiate new session
    const code_verifier = cryptography.verifier();
    const code_challenge = cryptography.challenge(code_verifier);
    localStorage.setItem(TokenService.codeVerifierKey, code_verifier);

    const callbackUri = process.env.REACT_APP_REDIRECT_URI_NOT_ENCODED || '';
    const client_id = process.env.REACT_APP_CLIENT_ID || '';
    const pingUrl = process.env.REACT_APP_FEDERATION_SERVER_URL || '';
    const pars = `client_id=${client_id}&scope=UPX&response_type=code&redirect_uri=${callbackUri}&code_challenge=${code_challenge}&code_challenge_method=S256`;

    return `${pingUrl}?${pars}`;
  }

  createNewSessionforSACBL(): string {
    // Remove access token
    const accessToken = sessionStorage.getItem(TokenService.accessTokenKey);
    if (accessToken) {
      sessionStorage.removeItem(TokenService.accessTokenKey);
    }

    // Remove refresh token
    const refreshToken = sessionStorage.getItem(TokenService.refreshTokenKey);
    if (refreshToken) {
      sessionStorage.removeItem(TokenService.refreshTokenKey);
    }

    // Initiate new session
    const code_verifier = cryptography.verifier();
    const code_challenge = cryptography.challenge(code_verifier);
    localStorage.setItem(TokenService.codeVerifierKey, code_verifier);

    const callbackUri = process.env.REACT_APP_REDIRECT_URI_NOT_ENCODED_SACBL || '';
    const client_id = process.env.REACT_APP_CLIENT_ID_SACBL || '';
    const pingUrl = process.env.REACT_APP_FEDERATION_SERVER_URL || '';
    const pars = `client_id=${client_id}&scope=UPX&response_type=code&redirect_uri=${callbackUri}&code_challenge=${code_challenge}&code_challenge_method=S256`;

    return `${pingUrl}?${pars}`;
  }

  async createTokenHash(encryptedToken: string): Promise<string> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const requestOptions: any = {
      method: 'POST',
      body: JSON.stringify(encryptedToken),
      headers,
    };

    const result = await fetch(`${process.env.REACT_APP_API_URL}/user/token`, requestOptions);
    const tokenHash = await result.text();
    return tokenHash;
  }

  async revokeAuth(encryptedToken: string): Promise<boolean> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', encryptedToken);

    const requestOptions: any = {
      method: 'DELETE',
      headers,
    };

    const result = await fetch(`${process.env.REACT_APP_API_URL}/user/token`, requestOptions);
    const isRevoked = result.status;
    return isRevoked === 200;
  }

  async revokePingToken(refreshToken:string, sessionType: string): Promise<any> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

    const urlencoded = new URLSearchParams();
    urlencoded.append('token', refreshToken);
    urlencoded.append('token_type_hint', 'refresh_token');

    if (sessionType == TokenService.newSession) {
      urlencoded.append('client_id', `${process.env.REACT_APP_CLIENT_ID}`);
    }

    if (sessionType == TokenService.resumeSession) {
      urlencoded.append('client_id', `${process.env.REACT_APP_CLIENT_ID_SACBL}`);
    }

    const requestOptions:any = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    const result = await fetch(`${process.env.REACT_APP_FEDERATION_REVOKE_URL}`, requestOptions);
    const isRevoked = result.status;
    return isRevoked === 200;
  }

  async refreshToken(): Promise<void> {
    const refreshToken = sessionStorage.getItem(TokenService.refreshTokenKey);
    const token = refreshToken != null ? refreshToken : '';

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    const urlencoded = new URLSearchParams();
    urlencoded.append('grant_type', 'refresh_token');

    urlencoded.append('refresh_token', token);

    const requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
    };

    const response = await fetch(`${process.env.REACT_APP_FEDERATION_TOKEN_URL}`, requestOptions);

    const json = await response.json();

    const newHash = await this.createTokenHash(json.access_token);
    this.storeTokenHash(newHash, token);

    return;
  }

  storeTokenHash(tokenHash:string, refreshToken:string, clearCodeVerifier:boolean = false): void {
    if (tokenHash) {
      sessionStorage.setItem(TokenService.accessTokenKey, tokenHash);
    }

    if (refreshToken) {
      sessionStorage.setItem(TokenService.refreshTokenKey, refreshToken);
    }

    if (clearCodeVerifier) {
      localStorage.removeItem(TokenService.codeVerifierKey);
    }
  }

  async clearSession(sessionType: string) : Promise<void> {
    const accessToken = sessionStorage.getItem(TokenService.accessTokenKey) || '';
    if (accessToken) {
      await this.revokeAuth(accessToken);
      sessionStorage.removeItem(TokenService.accessTokenKey);
      console.debug('Access Token Cleared');
      appInsights.trackTrace({ message: 'Access Token Cleared' });
    }

    const refreshToken = sessionStorage.getItem(TokenService.refreshTokenKey) || '';
    if (refreshToken) {
      // lets make sure we revoke refresh token
      await this.revokePingToken(refreshToken, sessionType);
      sessionStorage.removeItem(TokenService.refreshTokenKey);
      console.debug('Refresh Token Cleared');
      appInsights.trackTrace({ message: 'Refresh Token Cleared' });
    }
  }
}
export default TokenService;
